import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ContactsPlaceholderIcon = (props: IconProps) => (
  <Icon width="360px" height="374px" viewBox="0 0 360 374" {...props}>
    <ellipse
      cx="180.359"
      cy="187.557"
      fill="#D6D6D6"
      opacity=".38"
      rx="179.859"
      ry="179.765"
    />
    <mask
      id="a"
      width="21"
      height="20"
      x="74"
      y="63"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M74.003 63.446h20.046v18.923H74.003z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#F5F5F5"
        fillRule="evenodd"
        d="M78.05 115.762h46.069V63.446h-46.07c8.837 0 16 7.164 16 16v20.316c0 8.836-7.163 16-16 16Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#F5F5F5"
      d="M94.05 63.446h259.283a8 8 0 0 1 8 8v41.881a8 8 0 0 1-8 8H102.049a8 8 0 0 1-8-8v-49.88Z"
    />
    <path
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
      d="M186.257 80.369h155.257"
    />
    <path
      stroke="#CCE4FF"
      strokeLinecap="round"
      strokeWidth="4"
      d="M113.868 80.369h62.821"
    />
    <path
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
      d="M113.868 91.5h227.646M113.868 103.744h56.139"
    />
    <mask
      id="b"
      width="21"
      height="20"
      x="74"
      y="253"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M74.003 253.786h20.046v18.923H74.003z" />
    </mask>
    <g mask="url(#b)">
      <path
        fill="#F5F5F5"
        fillRule="evenodd"
        d="M78.05 306.101h46.069v-52.315h-46.07c8.837 0 16 7.163 16 16v20.315c0 8.837-7.163 16-16 16Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#F5F5F5"
      d="M94.05 253.786h259.283a8 8 0 0 1 8 8v41.881a8 8 0 0 1-8 8H102.049a8 8 0 0 1-8-8v-49.881Z"
    />
    <path
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
      d="M113.868 270.708h94.004"
    />
    <path
      stroke="#CCE4FF"
      strokeLinecap="round"
      strokeWidth="4"
      d="M218.554 270.708h94.004"
    />
    <path
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
      d="M113.868 281.839h227.646M113.868 294.083h67.276"
    />
    <ellipse cx="98.504" cy="309.44" fill="#99CAFF" rx="13.364" ry="13.357" />
    <path
      fill="#fff"
      d="M91.358 315.284h2.598v-7.791h-2.598v7.791Zm14.292-7.142c0-.714-.585-1.299-1.299-1.299h-4.1l.618-2.967.019-.208a.974.974 0 0 0-.286-.688l-.688-.682-4.275 4.279a1.27 1.27 0 0 0-.383.916v6.493c0 .714.584 1.298 1.299 1.298h5.847c.539 0 1-.324 1.195-.792l1.962-4.578a1.27 1.27 0 0 0 .091-.474v-1.298Z"
    />
    <mask
      id="c"
      width="21"
      height="20"
      x="-3"
      y="159"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M-2.841 159.173h20.046v18.923H-2.841z" />
    </mask>
    <g mask="url(#c)">
      <path
        fill="#F5F5F5"
        fillRule="evenodd"
        d="M1.205 211.488h46.07v-52.315H1.205c8.837 0 16 7.163 16 16v20.315c0 8.837-7.163 16-16 16Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#F5F5F5"
      d="M17.205 159.173H276.49a8 8 0 0 1 8 8v41.881a8 8 0 0 1-8 8H25.205a8 8 0 0 1-8-8v-49.881Z"
    />
    <path
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
      d="M37.024 176.095h194.235M152.847 187.226H264.67"
    />
    <path
      stroke="#CCE4FF"
      strokeLinecap="round"
      strokeWidth="4"
      d="M37.024 187.226h104.027"
    />
    <path
      stroke="#EBEBEB"
      strokeLinecap="round"
      strokeWidth="4"
      d="M37.024 199.47h151.915"
    />
    <ellipse cx="23.887" cy="219.28" fill="#99CAFF" rx="13.364" ry="13.357" />
    <g clipPath="url(#d)">
      <path
        fill="#fff"
        d="M16.741 225.123h2.599v-7.791H16.74v7.791Zm14.292-7.142c0-.714-.584-1.298-1.299-1.298h-4.1l.618-2.968.02-.208a.976.976 0 0 0-.286-.688l-.69-.682-4.274 4.279a1.27 1.27 0 0 0-.383.916v6.493c0 .714.585 1.298 1.3 1.298h5.846c.54 0 1-.324 1.195-.792l1.962-4.577c.059-.15.091-.305.091-.474v-1.299Z"
      />
    </g>
    <rect
      width="56.798"
      height="20.036"
      x="253.305"
      y="32.28"
      fill="#E5F2FF"
      rx="10.018"
    />
    <ellipse cx="264.442" cy="42.298" fill="#99CAFF" rx="3.341" ry="3.339" />
    <ellipse cx="275.579" cy="42.298" fill="#99CAFF" rx="3.341" ry="3.339" />
    <ellipse cx="286.716" cy="42.298" fill="#99CAFF" rx="3.341" ry="3.339" />
    <ellipse cx="297.853" cy="42.298" fill="#99CAFF" rx="3.341" ry="3.339" />
    <defs>
      <clipPath id="d">
        <path fill="#fff" d="M16.091 211.488h15.591v15.583h-15.59z" />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(ContactsPlaceholderIcon);
